import { IsDefined, IsNotEmpty } from 'class-validator';

import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { EntityModel } from 'src/core/services/data/models';
import { ContextService } from 'src/core/services/context.service';

export class EmailDocumentTemplateDataService extends DataService<typeof Model.General.Logic.ViewModels.EmailDocumentTemplateItem, Model.General.Logic.ViewModels.EmailDocumentTemplateItem, IEmailDocumentTemplateItem> {
	private id: number = 0;
	private getNextId(): number {
		this.id--;
		return this.id;
	}

	protected map(entity: Model.General.Logic.ViewModels.EmailDocumentTemplateItem): IEmailDocumentTemplateItem {
		return new EmailDocumentTemplateItemModel(entity);
	}

	static make(context?: ContextService): EmailDocumentTemplateDataService {
		return new EmailDocumentTemplateDataService(context, ctx => ctx.EmailDocumentTemplates);
	}

	add(defaultLanguage: string): Model.General.Logic.ViewModels.EmailDocumentTemplateItem {
		const entity = new Model.General.Logic.ViewModels.EmailDocumentTemplateItem();
		(entity as any).dynamicProperties = {
			html: {
				[defaultLanguage]: '',
			},
			subject: {
				[defaultLanguage]: '',
			}
		};

		return entity;
	}
}

export class EmailDocumentTemplateItemModel extends EntityModel<Model.General.Logic.ViewModels.EmailDocumentTemplateItem, IEmailDocumentTemplateItem> implements IEmailDocumentTemplateItem {
	@property<EmailDocumentTemplateItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;
	
	@property<any>(o => o.entity.dynamicProperties, (o, value) => o.entity.dynamicProperties = value)
	public dynamicProperties: { [prop: string]: any }

	@IsNotEmpty({ message: 'Category is required' })
	@IsDefined({ message: 'Category is required' })
	@property<EmailDocumentTemplateItemModel>(o => o.entity.categoryId, (o, value) => o.entity.categoryId = value)
	public categoryId: number;

	@property<EmailDocumentTemplateItemModel>(o => o.entity.category, (o, value) => o.entity.category = value)
	public category: IDocumentTemplateCategorySummary;

	@property<EmailDocumentTemplateItemModel>(o => o.entity.name, (o, value) => o.entity.name = value)
	public name: string;

	@IsNotEmpty({ message: 'Target is required' })
	@IsDefined({ message: 'Target is required' })
	@property<EmailDocumentTemplateItemModel>((o) => o.entity.target, (o, value) => o.entity.target = value)
	public target: number;
}



// WEBPACK FOOTER //
// ./src/app/general/email-document-template/form/email-document-template-form.data.ts